exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".beneficios-carrusel__contenedor{min-height:104px;position:relative}.beneficios-carrusel__beneficio{opacity:0;position:absolute;-webkit-transition:all .8s ease-in-out;-o-transition:all .8s ease-in-out;transition:all .8s ease-in-out}.beneficios-carrusel__beneficio-visible{opacity:1}.beneficios-carrusel__controles{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;margin-top:8px;padding-bottom:16px;padding-top:16px}.beneficios-carrusel__control{padding:4px}.beneficios-carrusel__circulo{border:1px solid #fff;border-radius:50%;height:8px;width:8px}.beneficios-carrusel__circulo-seleccionado{background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":false}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null]}!./src/css/components/BannerInicio/BeneficiosCarrusel.css
// module id = 711
// module chunks = 8